import moment, { Moment } from 'moment'

type TimeInterval = {
  start: string
  end: string
}

// TODO Нужно продолжить оптимизацию - учитывать сортировку
// В отсортированных данных не нужно перебирать ВЕСЬ массив, достаточно будет начать перебирать с начала или конца и остановиться
export const filterDataByTimeInterval = <Return>(
  data: Return[],
  timeInterval: TimeInterval,
  field: keyof Return
): Return[] => {
  const startTime: Moment = moment(timeInterval.start)
  const endTime: Moment = moment(timeInterval.end)

  // Проверяем валидность границ интервала
  if (!startTime.isValid() || !endTime.isValid()) {
    throw new Error('Invalid time interval boundaries')
  }

  return data.filter(item => {
    const itemTime: Moment = moment(item[field] as string)

    // Исключаем записи с невалидными датами и проверяем попадание в интервал
    return itemTime.isValid() && itemTime.isBetween(startTime, endTime, null, '[]')
  })
}
